import axios from "axios";
import { useEffect, useState } from "react";
import { webApiAutoresIndice } from ".././../../routes/endpoints";
import { abecedarioDTO } from "../../../models/Colecciones.model";
import { base_url } from "../../../constants";
import { Link } from "react-router-dom";
import { ventana } from "../../../utilities/Alertas";

export default function Recuadros(){   
    const [abecedario, setAbecedario] = useState<abecedarioDTO[]>();
    useEffect(()=>{
        axios.get(webApiAutoresIndice).then((response) => {
            setAbecedario(response.data)                           
        }).catch(err => console.warn(err));  
    },[]);  
    const sinRegistros = () =>{ ventana('', 'No hay autores disponibles.', 'info') }
    return(
        <div className="col-11 mt-3">            
          <div className="row">
              { abecedario?.map((abe, i)=>               
                    (abe.existe)?                         
                        <Link key={i} to={`/${base_url}/autores/${abe.id}`} className="col-12 col-md-1 col-lg-1 px-0 cuadros_letras text-center justify-content-center">
                            <div><p className="px-2">{abe.caracter}</p></div>
                        </Link> 
                    :
                        <Link key={i} to="#" onClick={sinRegistros} className="col-12 col-md-1 col-lg-1 px-0 cuadros_letras text-center justify-content-center">
                            <div><p className="px-2">{abe.caracter}</p></div>
                        </Link> 
                                      
                ) }            
            </div>
        </div>
    )
}